import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import { EditorState, RichUtils } from 'draft-js';
import { stateFromHTML } from 'draft-js-import-html';
import { stateToHTML } from 'draft-js-export-html';
import EditorSimple from './EditorSimple';
import EditorNoControls from './EditorNoControls';
import 'draft-js/dist/Draft.css';
import './rich-text-editor.less';

const RichTextEditor = ( { rawHTML = '', locale = '', controls, placeholder, draftJSOptions = {}, onChange, id, readOnly } ) => {

    const [ editorState, setEditorState ] = useState(
        () => EditorState.createWithContent( stateFromHTML( rawHTML ) )
    );
   
    const toggleBlockType = ( blockType ) => {
        setEditorState(	RichUtils.toggleBlockType( editorState,	blockType ) );
    };

    const toggleInlineStyle = ( inlineStyle ) => { 
        setEditorState( RichUtils.toggleInlineStyle( editorState, inlineStyle ) );
    };
    
    // Set new editor state when the initailRawHTML or locale change
    useEffect( () => {
        const newState = EditorState.createWithContent( stateFromHTML( rawHTML ) );
        setEditorState( newState );
    }, [ rawHTML, locale ] );

    useEffect( () => {
        let currentHTML = stateToHTML( editorState.getCurrentContent(), draftJSOptions.stateToHTML || {} );
        const lastChangeType = editorState.getLastChangeType();
        
        if ( currentHTML === '<br>' || currentHTML === '<p><br></p>' ) {
            currentHTML = '';
        }
        
        if ( lastChangeType && onChange ) {
            onChange( currentHTML );
        }
    }, [ editorState, onChange, draftJSOptions ] );

    const handleCopyClick = () => {
        const currentHTML = stateToHTML( editorState.getCurrentContent(), draftJSOptions.stateToHTML || {} );
        
        navigator.clipboard.writeText( currentHTML ).then( () => {
            message.success( 'HTML successfully copied to clipboard' ); 
        }, () => {
            message.error( 'Error copying to clipboard' );     
        } );
    };

    const handlePasteClick = () => { 
        navigator.clipboard.readText().then( text => {
            const newState = EditorState.createWithContent( stateFromHTML( text ) );
            setEditorState( newState );
        } )
        .catch( e => message.error( 'Error pasting from clipboard' ) );
    };

    return (
        <div className={ `rte-root ${ readOnly ? 'readonly' : '' }` }>
            { ( controls === 'none' || readOnly  ) ?
                <EditorNoControls
                    id= { id }
                    editorState={ editorState }
                    setEditorState={ setEditorState }
                    toggleBlockType={ toggleBlockType }
                    toggleInlineStyle={ toggleInlineStyle }
                    placeholder={ placeholder }
                />
                :
                <EditorSimple
                    id= { id }
                    editorState={ editorState }
                    setEditorState={ setEditorState }
                    toggleBlockType={ toggleBlockType }
                    toggleInlineStyle={ toggleInlineStyle }
                    placeholder={ placeholder }
                    handleCopyClickCallback={ handleCopyClick }
                    handlePasteClickCallback={ handlePasteClick }
                />
            }
        </div>
    );
};

export default RichTextEditor;
